/**
 * Created by karora on 11/03/17.
 */
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from './services/api.service';
import { ProfileService } from './services/profile.service';
import { UserProfile } from './types/user-profile';

@Component({
  selector: 'hub-admin',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0%)'
      })),
      state('out', style({
        transform: 'translateX(-100%)'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ]),
  ],
})

export class AppComponent implements OnInit {

  get loggedIn(): boolean {
    return ApiService.IsLoggedIn();
  }
  private static title = 'HUB Administration';
  private static instance: AppComponent;
  private currentRoute = '/';
  menuState = 'out';
  userProfile: UserProfile;

  public static IsLoggedIn(): boolean {
    return this.instance.loggedIn;
  }

  public static SetTitle(newTitle: string): void {
    AppComponent.title = newTitle;
    let titleShite = document.getElementById('title');
    if (titleShite && newTitle) { titleShite.innerText = newTitle; }
  }

  public static SetUser(profile: UserProfile): void {
    AppComponent.instance.userProfile = profile;
    let userShite = document.getElementById('username');
    if (userShite && profile && profile.name) { userShite.innerText = profile.name; }
  }

  public static GetUserProfile(): UserProfile {
    return AppComponent.instance.userProfile;
  }

  public static zpad(v: any, n: number): string {
    let s: string = '000000000000' + v;
    return s.substring(s.length - n);
  }

  static getCurrentRoute(): string {
    return AppComponent.instance.currentRoute;
  }

  constructor(
    private router: Router,
    private profileService: ProfileService,
  ) {
    if (!AppComponent.instance) {
      AppComponent.instance = this;
    } else {
      console.error('We seem to be creating a second instance of AppComponent!!!');
    }
    this.currentRoute = this.router.url;
  }

  ngOnInit(): void {
    try {
      this.profileService.GetProfile().subscribe(
        profile => AppComponent.SetUser(profile),
      );
    } catch (e) {
      console.log(e);
    }
    if (this.menuState === 'in') {
      this.toggleMenu();
    }
    this.router.events.subscribe((event) => {
      // console.log('route changed: ' + event);
      if (event && event['url'] && AppComponent.instance.currentRoute !== event['url']) {
        AppComponent.instance.currentRoute = event['url'];
        console.log('Route changed to: ' + event['url']);
      }
      this.hideMenu();
    });
  }

  // Called from in the HTML
  toggleMenu(): void {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }

  hideMenu(): void {
    this.menuState = 'out';
  }
}
